//Contracts:
import { particles } from 'app/contracts/Particles';
//Enums:
import { ParticleLayoutType } from 'app/enum/Particles';
//Library:
import { ParticleField } from 'particles/ParticleField';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';

export class ScreensGridField extends ParticleField {
	constructor(sceneProps: particles.SceneProps, container: PIXI.Container, config: particles.ParticleFieldConfig) {
		super(sceneProps, container, config);

		//Pre-extraction, ParticleField hard-coded HomeParticle as the particle
		//class for every field; keep constructing HomeParticle into the field's
		//default particle container. Particle creation is deferred (setTimeout),
		//so assigning the factory right after super() is always in time:
		config.particleFactory = (particleConfig: particles.ParticleConfig) =>
			new HomeParticle(sceneProps, this._particleContainer, particleConfig);
	}

	protected init(): void {
		this.reposition(
			ParticleLayoutType.PERSPECTIVE,
			{ x: 0.36333 + 0.41, y: -0.45 },
			{ w: 0.04, h: 0.4 },
			null,
			this.particles
		);
	}
}
